import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GoalCard from '../../widgets/GoalCard';

import { dbActions } from '../../../redux/modules/firebase/databaseModule';

class GoalsList extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    _subscribeToGoals(props) {
        const { user, getGoals, subscribeToGoals } = props;
        this.setState({ loading: true });
        if (user && user.uid) {
            getGoals(user.uid)
                .then(() => subscribeToGoals(user.uid))
                .then(() => {
                    this.setState({ loading: false });
                });
        }
    }

    componentWillMount() {
        this._subscribeToGoals(this.props);
    }

    componentWillUnmount() {
        const { user, unsubscribeToGoals } = this.props;
        if (user && user.uid) {
            unsubscribeToGoals(user.uid);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user !== nextProps.user) {
            if (this.props.user && this.props.user.uid) {
                this.props.unsubscribeToGoals(this.props.user.uid);
            }
            if (nextProps.user) {
                this._subscribeToGoals(nextProps);
            }
        }
    }

    render() {
        const { user, goals, dispatch } = this.props;
        const { loading } = this.state;

        if (loading) {
            // TODO clean up
            return <div>Loading</div>;
        }

        if (!goals || !goals.size) {
            // TODO clean up
            return <div>Create First Goal</div>;
        }

        const sorted = goals.sortBy(goal => goal.get('end'));

        return (
            <div className="Goals-list container-fluid">
            {sorted.map((value, key) => (
                <GoalCard key={key} id={key} user={user} goal={value} dispatch={dispatch} />
            )).toArray()}
            </div>
        );
    }
}

GoalsList.propTypes = {
    user: PropTypes.object,
    goals: PropTypes.object, // ImmutableMap
    getGoals: PropTypes.func.isRequired,
    subscribeToGoals: PropTypes.func.isRequired,
    unsubscribeToGoals: PropTypes.func.isRequired,

    dispatch: PropTypes.func,
};

export default connect(state => {
    const user = state.user.get('user');

    let goals = null;
    if (user && user.uid) {
        goals = state.firebase.getIn(['goals', user.uid]);
    }

    return { user, goals };
}, dispatch => ({
    dispatch,
    getGoals(uid) {
        return dispatch(dbActions.firebase.database.get(`goals/${uid}`));
    },
    subscribeToGoals(uid) {
        return dispatch(dbActions.firebase.database.subscribe(`goals/${uid}`));
    },
    unsubscribeToGoals(uid) {
        return dispatch(dbActions.firebase.database.unsubscribe(`goals/${uid}`));
    },
}))(GoalsList);



// WEBPACK FOOTER //
// ./src/components/pages/goals/GoalsList.js